import React from 'react'
import { Badge } from 'antd'
import PropTypes from 'prop-types'

import { THEME } from '../../../../core/constants'

import {
  SCHEDULED,
  IN_PROGRESS,
  PASSED,
  FAILED,
  SCRAPING_SESSION_STATUSES,
} from '../../../constants'

const backgroundColorByRank = {
  [SCHEDULED]: THEME.colors.blue,
  [IN_PROGRESS]: THEME.colors.yellow,
  [PASSED]: THEME.colors.green,
  [FAILED]: THEME.colors.red,
}

const ScrapingessionStatus = ({ status }) => (
  <Badge
    count={SCRAPING_SESSION_STATUSES[status].name}
    style={{
      backgroundColor: backgroundColorByRank[status],
    }}
  />
)

ScrapingessionStatus.propTypes = {
  status: PropTypes.string,
}

ScrapingessionStatus.defaultProps = {
  status: IN_PROGRESS,
}

export default ScrapingessionStatus
